/* eslint-disable import/prefer-default-export */
import { format } from '@breezeway/brzw-react-core';
import _ from 'lodash';

const {
  phone: { formatNumberByCountry, replaceCountryCode },
} = format;

const normalizeDialCode = dialCode =>
  !_.startsWith(dialCode, '+') ? `\\+${dialCode}` : _.replace(dialCode, '+', '\\+');

export const getFormattedNumberWithoutCountryCode = (number, countryCode, dialCode) => {
  const formattedNumber = formatNumberByCountry(number, countryCode);

  if (formattedNumber) {
    const phoneNumberWithoutDialCode = _.trim(
      replaceCountryCode(
        { dialCode: normalizeDialCode(dialCode) },
        { dialCode: '' },
        formatNumberByCountry(number, countryCode),
      ),
    );

    return !_.startsWith(phoneNumberWithoutDialCode, '-')
      ? phoneNumberWithoutDialCode
      : _.trim(phoneNumberWithoutDialCode, '-');
  }

  return number;
};

export const removeNumberFormatting = phoneNumber => _.replace(phoneNumber, /[\s()-]/g, '');
